import Container from 'react-bootstrap/Container';
import { Modal, Button,Form, Alert } from "react-bootstrap";
import {Sida,Rubrik,ContentWrapper} from "../ContentStyles";
import React, {useMemo, useState} from 'react';
import MaterialReactTable from 'material-react-table';
import useBackend, {Check} from '../../services/useBackend_v2';

export default function Productgroups(props) {
   const [object2Edit,  setObject2Edit]       = useState({Name:"", ProductsCnt:0, Active:false});
   const [editShow, setEditShow]      = useState(false);
   const [addShow, setAddShow]      = useState(false);

   var typingTimeout = null;

   const { loading, data, Refresh, XCall, resultVisible, resultText, resultVariant, SpinnerX } = useBackend('/api/admin/register');

   function handleChange(event){
      clearTimeout(typingTimeout);
      typingTimeout = setTimeout(handleGroupUpdate, 475);
   }

   async function handleGroupUpdate(){
      const EventForm                 = document.getElementById('productGroupForm');
      const formData = new FormData(EventForm),formDataObj = Object.fromEntries(formData.entries());
      formDataObj.Active       = formData.has('Active') ? true : false;
      formDataObj.Default       = formData.has('Default') ? true : false;
      await XCall('/api/admin/productgroups/'+object2Edit.Guid, 'PATCH', 3000, formDataObj, true);      
   }   

   const editProductGroupHandler = (event, rowData)  =>  {
      setObject2Edit(rowData.original);
      setEditShow(!editShow);
   }

   const handlerGroupAdd = async (e)  =>  {
      const EventForm                 = document.getElementById('productGroupAddForm');
      const formData = new FormData(EventForm),formDataObj = Object.fromEntries(formData.entries());
      await XCall('/api/admin/productgroups', 'POST', 3000, formDataObj, true);      
   }

   const columns = useMemo(() => [
         { size: 40, accessorKey: 'Name',  header: 'Namn' },
         { size: 40, accessorKey: 'ProductsCnt',  header: 'Antal varor' },
         { size: 20, accessorKey:'Default', header: 'Standard', enableOrdering: true, enableColumnOrdering: true, enablePinning: true, enableColumnActions: true,
            Cell: ({ cell }) => ( <Check checked={cell.getValue()}/> ),
         },
         { size: 20, accessorKey:'Active', header: 'Aktiv', enableOrdering: true, enableColumnOrdering: true, enablePinning: true, enableColumnActions: true,
            Cell: ({ cell }) => ( <Check checked={cell.getValue()}/> ),
         },
   ]);

    return (
      <ContentWrapper> 
         <Modal show={editShow} onHide={()=> {setEditShow(!editShow); Refresh();} }>
            <Modal.Header closeButton>
               <Modal.Title>Editera produktgrupp</Modal.Title>
            </Modal.Header>

            <Modal.Body>
               <Form id="productGroupForm">
                  <Form.Group className="mb-3" >
                     <Form.Label>Namn</Form.Label>
                     <Form.Control type="text" name="Name" size='lg' onChange={handleChange} defaultValue={object2Edit.Name}/>
                  </Form.Group>

                  <Form.Group className="mb-3" >
                     <Form.Label>Antal varor</Form.Label>
                     <Form.Control type="text" name="ProductsCnt" disabled size='lg' defaultValue={object2Edit.ProductsCnt}/>
                  </Form.Group>      

                  <Form.Group className="mb-3" >
                     <Form.Check type="switch" name="Default" id="Default" label={'Standard'} defaultChecked={object2Edit.Default} value={object2Edit.Default} onChange={handleChange} />
                  </Form.Group>                               

                  <Form.Group className="mb-3" >
                     <Form.Check type="switch" name="Active" id="Active" label={'Aktiv'} defaultChecked={object2Edit.Active} value={object2Edit.Active} onChange={handleChange} />
                  </Form.Group>
                  <Alert hidden={!resultVisible} variant={resultVariant} className="FormSpace">{resultText}</Alert>
               </Form>
            </Modal.Body>
            <Modal.Footer>
               {/* <Button variant="warning" onClick={()=>setEditShow(!editShow)}>Avbryt</Button> */}
            </Modal.Footer>
         </Modal>

         <Modal show={addShow} onHide={()=> {setAddShow(!addShow); Refresh();}}>
            <Modal.Header closeButton>
               <Modal.Title>Lägg till produktgrupp</Modal.Title>
            </Modal.Header>

            <Modal.Body>
               <Form id="productGroupAddForm">
                  <Form.Group className="mb-3" >
                     <Form.Label>Namn</Form.Label>
                     <Form.Control type="text" name="name" size='lg' defaultValue={""}/>
                  </Form.Group>
               </Form>
               <Alert hidden={!resultVisible} variant={resultVariant} className="FormSpace">{resultText}</Alert> 
            </Modal.Body>

            <Modal.Footer>
               <Button variant="primary" onClick={()=>handlerGroupAdd()}>Spara</Button>
            </Modal.Footer>
         </Modal>

         <Container>
            <Sida>
               {!loading &&
               <MaterialReactTable
                     columns={columns} data={data.productGroups} initialState={props.initialState}
                     muiTablePaginationProps={props.muiTablePaginationProps} 
                     renderTopToolbarCustomActions={() => (<Rubrik>Varugrupper</Rubrik>)}
                     muiTablePaperProps={{ elevation: 0, sx: { borderRadius: '0', border: '0px dashed #e0e0e0' } }}
                     muiTableBodyRowProps={({ row }) => ({ onClick: (event) => { editProductGroupHandler(event, row); }, sx: { cursor: 'pointer' } })}                      
               />}
               <Button className="QmeButton" variant="primary" type="submit" onClick={()=>setAddShow(!addShow)}>Ny varugrupp</Button> 
            </Sida>
            
         </Container>
       </ContentWrapper>
    );
 }